import { reflect } from '@effector/reflect';
import { Button, Checkbox, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { X } from 'lucide-react';
import { translated } from 'shared/lib';
import { accountTreeModel } from '../../model';
import { AccountTreeCurrencies } from '../account-tree-currencies';
import { AccountTreeEmpty } from '../account-tree-empty';
import { AccountTreeItem } from '../account-tree-item';
import { AccountTreeSearch } from '../account-tree-search';
import cls from './account-tree.module.scss';

const SelectionField = reflect({
	view: Checkbox,
	bind: {
		label: translated('account-tree.flat-select'),
		checked: accountTreeModel.$flatSelect,
		onChange: (e) => accountTreeModel.setFlatSelect(e.currentTarget.checked),
		'data-test-id': 'account-tree-flat-select',
	},
});

const ClearButton = reflect({
	view: Button,
	bind: {
		children: translated('account-tree.clear-all'),
		variant: 'outline',
		rightSection: <X />,
		onClick: accountTreeModel.clearSelectedNodes,
		className: cls.accountTreeClear,
		disabled: accountTreeModel.$selectedNodes.map((nodes) => nodes.length === 0),
		'data-test-id': 'account-tree-clear-button',
	},
});

export const AccountTree = () => {
	const [initialized, roots, empty] = useUnit([
		accountTreeModel.$initialized,
		accountTreeModel.$roots,
		accountTreeModel.$empty,
	]);

	return (
		<div className={cls.accountTree}>
			<div className={cls.accountTreeContent}>
				<AccountTreeSearch />
				<AccountTreeCurrencies />
			</div>
			<div
				data-empty={empty || undefined}
				className={cls.accountTreeTree}
			>
				{initialized &&
					roots.map((root) => (
						<AccountTreeItem
							key={root.id}
							id={root.id}
						/>
					))}
				{initialized && empty && <AccountTreeEmpty />}
				{!initialized && <Loader />}
			</div>
			<div className={cls.accountTreeFooter}>
				<SelectionField />
				<ClearButton />
			</div>
		</div>
	);
};
